import React, { useState, useRef } from 'react';
import Swal from 'sweetalert2';
import { FaKey, FaSave, FaEdit, FaUser, FaEnvelope, FaCamera } from 'react-icons/fa';
import {
    ProfileContainer,
    ProfileTitle,
    ProfileForm,
    FormGroup,
    Label,
    Input,
    EditButton,
    ImageProfile,
    ContentImage,
    ChangePhotoButton
} from './UserProfileStyles';

const UserProfile = ({ user }) => {
    const inputRef = useRef(null);
    const [isEditing, setIsEditing] = useState(false);
    const [showPasswordInput, setShowPasswordInput] = useState(false);
    const [formData, setFormData] = useState({
        firstName: user.name,
        lastName: user.lastname,
        email: user.email,
        imagen_profile: user.imagen_profile,
        password: '********'
    });
    const [newPassword, setNewPassword] = useState('');
    const [previewImage, setPreviewImage] = useState(formData.imagen_profile || null);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const toggleEdit = () => {
        setIsEditing(!isEditing);
    };

    const handlePasswordChange = () => {
        setShowPasswordInput(true);
    };

    const saveNewPassword = () => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "¿Deseas cambiar tu contraseña?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, cambiar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire('¡Contraseña actualizada!', 'Tu contraseña ha sido cambiada.', 'success');
                setShowPasswordInput(false);
            }
        });
    };
    const openFileExplorer = () => {
   
          inputRef.current.value = "";
          inputRef.current.click();
       
     
      }
    return (
        <ProfileContainer>
            <ContentImage>
                {previewImage ? (
                    <ImageProfile src={previewImage} alt="Imagen de perfil" />
                ) : (
                    <FaUser size={80} color="#bbb" />
                )}

                {isEditing && (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '16px' }}>
                        <label htmlFor="upload-photo" onClick={() =>openFileExplorer ()}>
                            <ChangePhotoButton>
                                <FaCamera style={{ marginRight: '8px' }} />
                                Cambiar foto
                            </ChangePhotoButton>
                        </label>
                        <Input
                            type="file"
                            id="upload-photo"
                            name="image"
                            ref={inputRef}
                            style={{ visibility: 'hidden' }}
                            onChange={handleImageChange}
                        />
                    </div>
                )}
            </ContentImage>
            <ProfileForm>
                <FormGroup>
                    <Label><FaUser style={{ marginRight: 5 }} /> Nombre:</Label>
                    <Input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        disabled={!isEditing}
                    />
                </FormGroup>
                <FormGroup>
                    <Label><FaUser style={{ marginRight: 5 }} /> Apellido:</Label>
                    <Input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        disabled={!isEditing}
                    />
                </FormGroup>
                <FormGroup>
                    <Label><FaEnvelope style={{ marginRight: 5 }} /> Correo Electrónico:</Label>
                    <Input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        disabled={!isEditing}
                    />
                </FormGroup>
                <FormGroup>
                    <Label><FaKey style={{ marginRight: 5 }} /> Contraseña:</Label>
                    {showPasswordInput ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: "16px" }}>
                            <Input
                                type="password"
                                name="newPassword"
                                placeholder="Nueva contraseña"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <EditButton onClick={saveNewPassword}>
                                <FaSave style={{ marginRight: 5 }} />
                                Guardar Contraseña
                            </EditButton>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: "16px" }}>
                            <Input
                                type="password"
                                name="password"
                                value={formData.password}
                                disabled
                            />
                            {isEditing && (
                                <EditButton onClick={handlePasswordChange}>
                                    <FaEdit style={{ marginRight: 5 }} />
                                    Cambiar Clave
                                </EditButton>
                            )}
                        </div>
                    )}
                </FormGroup>
                <EditButton onClick={toggleEdit}>
                    {isEditing ? (
                        <>
                            <FaSave style={{ marginRight: 5 }} />
                            Guardar Cambios
                        </>
                    ) : (
                        <>
                            <FaEdit style={{ marginRight: 5 }} />
                            Editar Perfil
                        </>
                    )}
                </EditButton>
            </ProfileForm>
        </ProfileContainer>
    );
};

export default UserProfile;
